module.exports = __webpack_public_path__ + "static/media/shoe_dark.cdc387dc.png";